import styled from 'styled-components';


const ApplicantDataWrapper = styled.div`

.custom-calendar-input{
    input{
        border-right:none;
    }
    .p-button-icon-only{
        padding:0;
        background:transparent;
        color:rgb(110, 159, 187);
        border-left:none;
        border-radius:0;
        border-color:#ced4da;
        :focus{
            box-shadow:none;
        }
    }

    &.p-invalid{
        .p-button-icon-only{
            border-color:red;
            color:red; 
        }
    }
}
`;

export default ApplicantDataWrapper;